import { FrequencyMode, SupportedMediums } from 'modules/frequencyManagement/lib/types';
import { LABEL_BY_PERIOD } from 'modules/frequencyManagement/lib/constants';
import {
  MessageTypeSchema,
  MODE,
  OPTIMIZE_MIN_ALLOWED,
  OPTIMIZE_MAX_ALLOWED,
  CAPPING_MAX_ALLOWED,
  CAPPING_PERIOD,
  OPTIMIZE_PERIOD,
} from 'modules/frequencyManagement/contexts/FormProvider';
import { lowerCaseMessageMedium } from 'modules/frequencyManagement/lib/utils/mediumDomainUtils';
import { CaptionLight } from './MessageTypeRow.styled';

export const SummaryCaption = ({
  messageMedium,
  messageType,
}: {
  messageMedium: SupportedMediums;
  messageType: MessageTypeSchema;
}) => {
  const { [MODE]: mode } = messageType;

  if (mode === FrequencyMode.Off)
    return (
      <CaptionLight>
        Message type will follow the {lowerCaseMessageMedium(messageMedium)} frequency rule
      </CaptionLight>
    );

  if (mode === FrequencyMode.NoCap)
    return <CaptionLight>Messages of this type will never be skipped</CaptionLight>;

  if (mode === FrequencyMode.Cap) {
    const { [CAPPING_MAX_ALLOWED]: maxAllowed, [CAPPING_PERIOD]: period } = messageType;
    return (
      <CaptionLight>
        No more than{' '}
        <b>
          {maxAllowed} {lowerCaseMessageMedium(messageMedium)} messages per{' '}
          {LABEL_BY_PERIOD[period]}
        </b>{' '}
        per user
      </CaptionLight>
    );
  }

  if (mode === FrequencyMode.Optimize) {
    const {
      [OPTIMIZE_MIN_ALLOWED]: minAllowed,
      [OPTIMIZE_MAX_ALLOWED]: maxAllowed,
      [OPTIMIZE_PERIOD]: period,
    } = messageType;
    const label = LABEL_BY_PERIOD[period];

    return (
      <CaptionLight>
        <b>
          {minAllowed} to {maxAllowed} {lowerCaseMessageMedium(messageMedium)} messages per {label}
        </b>{' '}
        per user
      </CaptionLight>
    );
  }

  return null;
};
